import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Graph from '../../../../../components/graph/Graph';
import PmGraphInfo from './PmGraphInfo';

const PmGraph = ({
    customAndDefaultGoalByPeriod: { defaultGoal, customGoal },
    isCurrentSchoolYear,
    graphKey,
    graphOptions,
}) => {
    return useMemo(
        () => (
            <Graph graphKey={graphKey} graphOptions={graphOptions}>
                <PmGraphInfo
                    defaultGoal={defaultGoal}
                    customGoal={customGoal}
                    isGoalEnabled={isCurrentSchoolYear}
                />
            </Graph>
        ),
        [graphKey],
    );
};

PmGraph.defaultProps = {
    graphOptions: {},
    customAndDefaultGoalByPeriod: {},
    isCurrentSchoolYear: true,
    graphKey: '',
};

PmGraph.propTypes = {
    graphOptions: PropTypes.object,
    customAndDefaultGoalByPeriod: PropTypes.object,
    isCurrentSchoolYear: PropTypes.bool,
    graphKey: PropTypes.string,
};

export default PmGraph;
